import apiClient from "./axiosConfig";

export interface ForecastResponse {
  forecast?: string;
  error?: string;
}

// Type guard для ошибок Axios с кодом 402
function isAxios402Error(error: unknown): boolean {
  return (
    typeof error === "object" &&
    error !== null &&
    "response" in error &&
    typeof (error as { response?: { status?: number } }).response === "object" &&
    (error as { response: { status?: number } }).response?.status === 402
  );
}

export const fetchDailyForecast = async (
  date: string,
  timezone: string
): Promise<ForecastResponse> => {
  const response = await apiClient.post("/api/forecast/daily", { date, timezone });
  return response.data;
};

export const fetchTomorrowForecast = async (timezone: string): Promise<ForecastResponse> => {
  try {
    const response = await apiClient.post("/api/forecast/tomorrow", { timezone });
    return response.data;
  } catch (error: unknown) {
    if (isAxios402Error(error)) {
      return { error: "Subscription required" };
    }
    throw error;
  }
};

export const fetchWeeklyForecast = async (timezone: string): Promise<ForecastResponse> => {
  try {
    const response = await apiClient.post("/api/forecast/weekly", { timezone });
    return response.data;
  } catch (error: unknown) {
    if (isAxios402Error(error)) {
      return { error: "Subscription required" };
    }
    throw error;
  }
};

export const fetchMonthlyForecast = async (
  month: string,
  timezone: string
): Promise<ForecastResponse> => {
  try {
    const response = await apiClient.post("/api/forecast/monthly", { date: month, timezone });
    return response.data;
  } catch (error: unknown) {
    if (isAxios402Error(error)) {
      return { error: "Subscription required" };
    }
    throw error;
  }
};

export const fetchYearlyForecast = async (timezone: string): Promise<ForecastResponse> => {
  try {
    const response = await apiClient.post("/api/forecast/yearly", { timezone });
    return response.data;
  } catch (error: unknown) {
    if (isAxios402Error(error)) {
      return { error: "Subscription required" };
    }
    throw error;
  }
};
